import { render, staticRenderFns } from "./EntraOwners.vue?vue&type=template&id=115763cc"
import script from "./EntraOwners.vue?vue&type=script&lang=js"
export * from "./EntraOwners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115763cc')) {
      api.createRecord('115763cc', component.options)
    } else {
      api.reload('115763cc', component.options)
    }
    module.hot.accept("./EntraOwners.vue?vue&type=template&id=115763cc", function () {
      api.rerender('115763cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EntraOwners.vue"
export default component.exports